import {
  formBuilderData,
  tableBuilder,
  tableColum,
} from 'src/app/helper/interface/response';
import { Input } from '@angular/core';
import { VALIDATOR_PATTERNS } from 'src/app/helper/class/app-constant';

export const PRESCRIPTION_NOTES_LIST: formBuilderData[] = [
  {
    colName: 'prescription_notes',
    title: 'Prescription Notes',
    validator: [
      { name: 'required' },],
    col_size: 4
  },
  {
    colName: 'visits_on',
    title: 'Visited Date',
    type: 'DATETIME',
    validator: [
      { name: 'required' },],
    col_size: 4
  },
  {
    colName: 'doctor_fk_id',
    title: 'Doctor Name',
    type: 'select',
    apiTblName: 'doctor',
    selectKeyName: 'fname',
    selectPrimaryKey: 'user_id',
    event: { name: 'change', isCallback: true },
    col_size: 4
  },
]
export const DOCUMENT_LIST: formBuilderData[] = [
  {
    colName: 'remarks',
    title: 'Document Name ',
    validator: [
      { name: 'required' },]
  },
  {
    colName: 'document',
    title: 'Image ',
    colType: 'IMAGE',
    type: 'FILE',
    validator: [
      { name: 'required' },]
  },
]

export const TREATMENT_PLAN_DATA: formBuilderData[] = [
  {
    colName: 'treatment_fk_id',
    title: 'Treatment ',
    placeholder: 'Add Treatment',
    type: 'select',
    apiTblName: 'treatment',
    selectKeyName: 'treatmentName',
    selectPrimaryKey: 'id',
    event: { name: 'change', isCallback: true },
    validator: [{ name: 'required' }]
  },
  {
    colName: 'notes',
    title: 'Remarks',
    // col_size: 4,
    type: 'TEXTAREA',
    validator: [{ name: 'required' }]
  },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY',
    validator: [{ name: 'required' }]
  }

]

export const INVOICE_ADD_LIST: formBuilderData[] = [
  {
    colName: 'doctor_fk_id',
    title: 'Doctor Name',
    type: 'select',
    apiTblName: 'doctor',
    selectKeyName: 'fname',
    selectPrimaryKey: 'user_id',
    // event: { name: 'change', isCallback: true },
    validator: [
      { name: 'required' }
    ]
  },
  {
    colName: 'treatment_fk_id',
    title: 'Treatment ',
    placeholder: 'Add Treatment',
    type: 'select',
    apiTblName: 'treatment',
    selectKeyName: 'treatmentName',
    selectPrimaryKey: 'id',
    // col_size: 12,
    event: { name: 'change', isCallback: true },
    validator: [
      { name: 'required' }
    ]
  },
  {
    colName: 'consultation_date',
    title: 'Consulted Date',
    type: 'DATE',
    defaultValue: new Date(),
  },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY',
    defaultValue: '0',
  },
  {
    colName: 'add_tooth',
    title: 'Selected Tooth',
    hidden: true,
  },
  {
    colName: 'remarks',
    title: 'Remarks',
    type: 'TEXTAREA',
  }
];
export const INVOICEADD_LIST: formBuilderData[] = [
  {
    colName: 'description',
    title: 'Description ',
    col_size: 6,
    validator: [
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT_ONLY }],
  },
  {
    colName: 'amount',
    title: 'Amount',
    // defaultValue: '0',
    validator: [
      { name: 'required' },
      { name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER_FLOAT }],
    col_size: 6,
  },
];
export const INVOICE_ADD_LIST_MAIN: formBuilderData[] = [
  {
    colName: 'patient_fk_id',
    title: 'Patient Name',
    type: 'AUTOCOMPLETE',
    apiTblName: 'patient',
    selectKeyName: 'f_name',
    selectPrimaryKey: 'id',
    apiFunName: 'search',
    forceSelection: false,
    autoSearch: {
      titleKey: 'f_name',
      selectFieldKeys: ['patient_id', 'f_name', 'mobile_no'],
      separatorText: ' _',
    },
    event: { name: 'change', isCallback: true }
  },
];
export const LIST_COL_DATA: tableColum[] = [
  {
    colName: 'treatmentName',
    title: 'Treatment Name',
  },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY'
  },
  {
    colName: 'teeth_number',
    title: 'Tooth Number'
  },
  {
    colName: 'remarks',
    title: 'Remarks',
  },
  {
    colName: 'doctorName',
    title: 'Doctor Name'
  },
  {
    colName: 'consultation_date',
    title: 'Consultation Date',
  }
];
export const LIST_TREATMENT_PLAN: tableColum[] = [
  {
    colName: 'treatmentName',
    title: 'Treatment Name',
  },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY'
  },
  {
    colName: 'teeth_number',
    title: 'Tooth Number'
  },
  {
    colName: 'notes',
    title: 'Remarks',
  },
];

export const PRESCRIPTION_TABLE_LIST: tableColum[] = [
  {
    colName: 'prescription_notes',
    title: 'Prescription Notes'
  },
  {
    colName: 'medicine',
    title: 'Medicine'
  },
  {
    colName: 'doctorName',
    title: 'Doctor Name'
  },
  {
    colName: 'visits_on',
    title: 'Visited On',
  },
]

export const INVOICE_TBL_FORM: tableColum[] = [
  {
    colName: 'description',
    title: 'Description',

    // isEditable: true,
  },
  // { colName: 'add_tooth', title: 'Tooth' },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'NUMBER',
    // isEditable: true,
  },
];
export const PAYMENT_DATA: tableColum[] = [
  {
    colName: 'date',
    title: 'Date',
  },
  {
    colName: 'amount',
    title: 'Amount'
  },
  {
    colName: 'createdBy',
    title: 'Created By',
  },
];
export const INVOICE_LIST: tableColum[] = [
  {
    colName: 'invoice_id',
    title: 'Invoice ID',
  },
  {
    colName: 'patientName',
    title: 'Patient Name',
  },
  {
    colName: 'patient_id',
    title: 'Patient ID',
  },
  {
    colName: 'final_amount',
    title: 'Total Amount',
    colType: 'CURRENCY'
  },
  {
    colName: 'total_paid_amount',
    title: 'Amount Paid',
    colType: 'CURRENCY'
  },
  {
    colName: 'status',
    title: 'Status',
    colType: 'DROPDOWN',
    filterCol: {
      data: [
        { statusName: 'Paid', id: 1, color: 'success' },
        { statusName: 'Pending', id: 2, color: 'warning' },
        { statusName: 'Due', id: 3, color: 'primary' },
        { statusName: 'Cancelled', id: 4, color: 'danger' },
      ],
      selectPrimaryKey: 'id',
      selectKeyName: 'statusName',
      type: 'DROPDOWN',
    },
  },
  { colName: 'created_at', title: 'Date', colType: 'DATE' },
];

export const LIST_COL_ALL: tableColum[] = [
  {
    colName: 'invoice_id',
    title: 'Invoice ID',
  },
  {
    colName: 'patientName',
    title: 'Patient Name',
  },
  {
    colName: 'patient_id',
    title: 'Patient ID',
  },
  {
    colName: 'final_amount',
    title: 'Total Amount',
    colType: 'CURRENCY'
  },
  {
    colName: 'total_paid_amount',
    title: 'Amount Paid',
    colType: 'CURRENCY'
  },
  {
    colName: 'status',
    title: 'Status',
    filter: true,
    colType: 'DROPDOWN',
    sort: true,
    filterCol: {
      data: [
        { statusName: 'Paid', id: 1, color: 'success' },
        { statusName: 'Pending', id: 2, color: 'warning' },
        { statusName: 'Due', id: 3, color: 'primary' },
        { statusName: 'Cancelled', id: 4, color: 'danger' },
      ],
      selectPrimaryKey: 'id',
      selectKeyName: 'statusName',
      type: 'DROPDOWN',
    },
  },
  // {
  //   colName: 'created_byName',
  //   title: 'created By',
  // },
  { colName: 'invoice_date', title: 'Date', colType: 'DATE', filter: true, sort: true, filterCol: { type: 'DATE' }, },
];

export const PATIENT_DATA: formBuilderData[] = [
  {
    colName: 'patient_id',
    title: 'Patient Id',
  }, {
    colName: 'f_name',
    title: 'First Name ',
    col_size: 6,
  },
  {
    colName: 'l_name',
    title: 'Last Name ',
    col_size: 6,
  },
  {
    colName: 'mobile_no',
    title: 'Mobile number ',
    col_size: 6,
  },
];
export const REPORT_EXPORT_PAYMENT: formBuilderData[] = [
  {
    "colName": "payments_id",
    "title": "Payment Id"
  },
  {
    "colName": "date_of_payment",
    "title": "Payment Date"
  },
  {
    "colName": "invoice_id",
    "title": "Invoice Id"
  },
  {
    "colName": "payment_typeName",
    "title": "Payment Type Name"
  },
  {
    "colName": "Paymentstatus",
    "title": "Payment Status"
  },
  {
    "colName": "amount",
    "title": "Amount"
  },
  {
    "colName": "patientName",
    "title": "Patient Name"
  },
  {
    "colName": "patient_id",
    "title": "Patient Id"
  }
];

export const REPORT_EXPORT_INVOICE: formBuilderData[] = [
  {
    "colName": "patient_id",
    "title": "Patient Id"
  },
  {
    "colName": "patientName",
    "title": "Patient Name"
  },
  {
    "colName": "invoice_id",
    "title": "Invoice Id"
  },
  {
    "colName": "payments_id",
    "title": "Payment Id"
  },
  {
    "colName": "total_amount",
    "title": "Net Amount"
  },
  {
    "colName": "discount",
    "title": "Discount"
  },
  {
    "colName": "final_amount",
    "title": "Final Amount"
  },
  {
    "colName": "total_paid_amount",
    "title": "Total Paid Amount"
  },
  {
    "colName": "due_amount",
    "title": "Due Amount"
  },
  {
    "colName": "statusName",
    "title": "statusName"
  },
  {
    "colName": "created_date",
    "title": "Created Date"
  }

];

export const REPORT_EXPORT_EXPENSE: formBuilderData[] = [
  {
    "colName": "expense_id",
    "title": "Expense Id"
  },
  {
    "colName": "expense_typeName",
    "title": "Expense Type Name"
  },
  {
    "colName": "vendorName",
    "title": "Vendor Name"
  },
  {
    "colName": "amount",
    "title": "Amount"
  },
  {
    "colName": "paid_amount",
    "title": "Paid Amount"
  },
  {
    "colName": "balance_amount",
    "title": "Balance Amount"
  },
  {
    "colName": "payment_typeName",
    "title": "Payment Type Name"
  },
  {
    "colName": "created_date",
    "title": "Payment Date"
  },
  {
    "colName": "statusName",
    "title": "Payment Status"
  }
]

export const REPORT_EXPORT_APPOINTMENT: formBuilderData[] = [
  // {
  //   "colName": "appointment_for",
  //   "title": "Appointment For"
  // },
  {
    "colName": "appointment_date",
    "title": "Appointment Date"
  },
  {
    "colName": "appointment_time",
    "title": "Appointment Time"
  },
  {
    "colName": "doctorName",
    "title": "Doctor Name"
  },
  // {
  //   "colName": "token_no",
  //   "title": "Token No"
  // },
  {
    "colName": "patientName",
    "title": "Patient Name"
  },
  {
    "colName": "patient_id",
    "title": "Patient Id"
  },
  // {
  //   "colName": "mobile_no",
  //   "title": "Patient Mobile No"
  // },
  {
    "colName": "rescheduledStatusName",
    "title": "Rescheduled Status Name"
  },
  {
    "colName": "statusName",
    "title": "Status Name"
  },
  // {
  //   "colName": "created_byName",
  //   "title": "Created Name"
  // }
];

export const EXPORT_PATIENT_REPORT: formBuilderData[] = [
  {
    "colName": "patient_fullName",
    "title": "Patient Name"
  },
  {
    "colName": "patient_id",
    "title": "Patient ID"
  },
  {
    "colName": "email_id",
    "title": "Email ID"
  },
  {
    "colName": "mobile_no",
    "title": "Mobile No"
  },
  {
    "colName": "genderName",
    "title": "Gender Name"
  },
  {
    "colName": "dob",
    "title": "Date of Birth"
  },
  {
    "colName": "age",
    "title": "Age"
  },
  {
    "colName": "blood_groupName",
    "title": "Blood Group Name"
  },
  {
    "colName": "address",
    "title": "Address"
  },
  {
    "colName": "cityName",
    "title": "City"
  },
  {
    "colName": "stateName",
    "title": "State"
  },
  {
    "colName": "created_date",
    "title": "Created On"
  }

]

export const DAILY_ACTIVITY_REPORT: formBuilderData[] = [
  {
    "colName": "patient_id",
    "title": "Patient Id"
  },
  {
    "colName": "patient_fullName",
    "title": "Patient Name"
  },
  {
    "colName": "mobile_no",
    "title": "Mobile No"
  },
  {
    "colName": "treatmentName",
    "title": "Treatment Name"
  },
  {
    "colName": "doctorName",
    "title": "Doctor Name"
  },
  {
    "colName": "invoice_id",
    "title": "Invoice Id"
  },
  {
    "colName": "total_amount",
    "title": "Net Amount"
  },
  {
    "colName": "discount",
    "title": "Discount"
  },
  {
    "colName": "final_amount",
    "title": "Final Amount"
  },
  {
    "colName": "total_paid_amount",
    "title": "Total Paid Amount"
  },
  {
    "colName": "due_amount",
    "title": "Balance Amount"
  },
  {
    "colName": "payment_typeName",
    "title": "Payment Type Name"
  },
  {
    "colName": "date_of_payment",
    "title": "Payment Date"
  },
  {
    "colName": "statusName",
    "title": "Payment Status"
  },
  {
    "colName": "remarks",
    "title": "Remarks"
  },
]
